import el from "element-ui/src/locale/lang/el";

export function auth(url){
  if(sUrl.indexOf(url) > -1){
    return true
  }else{
    let isMatch = false
    for(let index in mUrl){
      if(url.indexOf(mUrl[index]) === 0 ){
        isMatch = true
      }
    }
    return isMatch
  }
}
const sUrl = [
 '/api-uaa/signup/user',
 '/api-uaa/password/reset',
 '/api-content/article/list',
 '/api-content/advertising/list',
 '/api-content/article/type/anon/list',
 '/api-visa/center/all',
 '/api-visa/center/index/permanent',
 '/api-visa/embassy/all',
 '/api-visa/email/document',
 '/api-visa/announcement/list',
 '/api-visa/announcement/detail/*',
 '/api-visa/permanent/list',
 '/api-visa/type/list',
 '/api-visa/product/list',
 '/api-visa/home',
 '/api-address/place/anon/list',
 '/api-wxmp/mp/jsconfig',
 '/api-wxmp/mp/grant',
 '/api-wxmp/mp/callback',
 '/api-wxmp/mini/session',
 '/api-pay/wxpay/payCallback',
 '/api-pay/alipay/payCallback',
 '/api-pay/wxpay/refundCallback',
 '/api-order/pay/alipay',
 '/api-apply/apply/sign',
 '/api-vois/reservation',
 '/api-express/route/callback']
const mUrl = [
  '/api-uaa/oauth/',
  '/api-uaa/validata/',
  '/api-user/users-anon/',
  '/api-file/token/user/upload/',
  '/api-visa/document/product/',
  '/api-content/article/detail/',
  '/api-visa/center/detail/',
  '/api-content/config/find/',
]



// WEBPACK FOOTER //
// ./src/utils/authPatch.js